import React from 'react';

const NewSheet: React.FC = () => {
  return (
    <div className="flex-1 flex flex-col bg-[#F7F7F8]">
      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-[#004C4B] mb-8">New Sheet</h1>
          <div className="bg-white rounded-lg shadow-sm p-6">
            <p className="text-gray-600">Create a new spreadsheet or financial document. This is where you can upload and manage your financial data.</p>
            <div className="mt-6">
              <button className="bg-[#004C4B] text-white px-6 py-3 rounded-lg hover:bg-[#003a3a] transition-colors">
                Upload Financial Document
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSheet;
